// @flow
import { createRef, useState } from "react";
import { Select } from "../components/Select";
import { ButtonGroup } from "../components/ButtonGroup";
import { Heading, QuestionWrapper } from "../components";
import { type QuestionProps } from "../components/MultiStageForm";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { validatePresence } from "./validators";

const validate = async (values = {}) => {
  const beds = values?.bedrooms === 0 ? null : values?.bedrooms;
  const bedrooms = await validatePresence(
    "bedrooms",
    "Please select the number of bedrooms",
  )(beds);
  const propertyType = await validatePresence(
    "propertyType",
    "Please select the property type",
  )(values?.propertyType);

  return { ...bedrooms, ...propertyType };
};

export const propertyTypeOptions = [
  {
    value: "FLAT",
    label: "Flat",
  },
  {
    value: "TERRACED",
    label: "Terraced",
  },
  {
    value: "SEMI_DETACHED",
    label: "Semi-detached",
  },
  {
    value: "DETACHED",
    label: "Detached",
  },
];

export const bedroomOptions = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6+",
  },
];

export const PropertyDetails = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  validationErrors,
}: QuestionProps<"propertyDetails">) => {
  const [propertyType, setPropertyType] = useState(
    initialValue?.propertyType || "",
  );
  const [bedrooms, setBedrooms] = useState(initialValue?.bedrooms || 0);

  const ref = createRef();
  useDesktopFocus(ref);

  return (
    <QuestionWrapper
      next={() => next({ propertyType, bedrooms }, validate)}
      dataTest="property-details-question"
    >
      <BackButton />
      <Heading>A bit about your property</Heading>
      <ButtonGroup
        label="Number of bedrooms"
        options={bedroomOptions}
        value={bedrooms}
        valid={!validationErrors?.bedrooms}
        onChange={setBedrooms}
      />
      <Select
        css="margin-top: 20px;"
        placeholder="Please select"
        labelAbove
        value={propertyType}
        label="Property type"
        options={propertyTypeOptions}
        valid={!validationErrors?.propertyType}
        onChange={setPropertyType}
      />
      <ActionButtons />
    </QuestionWrapper>
  );
};
